/**
 * UserTableLoading - Loading state component for user table.
 *
 * Displays a loading spinner in a Card wrapper.
 */

import { Loader2 } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from '@lean-agility/design-system/react';

export interface UserTableLoadingProps {
  /**
   * Title to display in the card header.
   */
  title: string;
}

export function UserTableLoading({ title = 'Users' }: UserTableLoadingProps) {
  return (
    <Card className="min-w-150">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="flex items-center justify-center p-12">
          <Loader2 className="size-6 animate-spin text-text-muted" />
        </div>
      </CardContent>
    </Card>
  );
}
